// extracted by mini-css-extract-plugin
export default {"wrapper":"ckeckbox_wrapper__bFBmE","title":"ckeckbox_title__nqVjn","value":"ckeckbox_value__bDqey","checkboxWrapper":"ckeckbox_checkboxWrapper__NAXMI"};